import { PaginationResponse } from "../../Shared/Pagination/PaginationResponse";
import { getApi, postApiPagination } from "../../Shared/Services/RestService";
import { ApplicationAuditLogResponseDTO, AuditResponseDTO } from "../Types/ApplicationLogs";




export const getAllApplicationLogs = (page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApi<PaginationResponse<ApplicationAuditLogResponseDTO>>("/admin/application-audit/logs", params);
};



export const getAllAuditLogs = (page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApi<PaginationResponse<AuditResponseDTO>>("/audit-logs/logs", params);
};



export const searchAuditLogs = (data:string, page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApi<PaginationResponse<AuditResponseDTO>>(`/audit-logs/search?${data.toString()}`, params);
};

export const searchApplicationAuditLogs = (payoad:string | Record<string, unknown>, page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return postApiPagination<PaginationResponse<ApplicationAuditLogResponseDTO>>("admin/application-audit/search", payoad, params);
};